module.exports = __webpack_public_path__ + "static/media/info-tool.05c43229.svg";